import { images } from "../../constants";
const works = [
   {
     title: "Recipe App",
     category: "Rails",
     description: "A full-stack application keeps track of all user's recipes, ingredients, keep track of what they have, create recipes, and generate a shopping list.",
     CodeLink: "https://github.com/Bantealem/Recipe-app",
     projectLink: "https://recipe-nn14.onrender.com/",
     imageUrl: images.recipe,
   },
   {
      title: " Meals Lover",
      category: "JavaScript HTML CSS API",
      description: "A user can view all the meals with their details and can also search for a specific meal. a user can also add comments and give likes",
      codeLink: "https://github.com/Bantealem/JS-Capstone-Project",
      projectLink: "https://mealslover.netlify.app/",
      imageUrl: images.tesla,
      
   },
   {
      title: "Book store",
      category: "React Redux API Booststrap",
      description: "Allows users to store books and check the list of books using API. They can remove unwanted books from lists.",
      codeLink: "https://github.com/Bantealem/book-store",
      projectLink:
         "https://soft-cajeta-ee544f.netlify.app/",
      imageUrl: images.uber,
      
   },

   {
      title: "Leaderboard",
      category: "JavaScript HTML CSS API",
      description: "Allows users to submit game scores. Which also displays scores submitted by different players. A user can add score infinitely",
      codeLink: "https://github.com/Bantealem/leaderboard",
      projectLink:
         "https://fancy-arithmetic-6379c7.netlify.app/",
      imageUrl: images.bracket,
      
   },
   {
      title: "Space Travler App",
      category: "React Redux API Bootstrap",
      description: "Allow users to book rockets and join selected space mission. Also, they can cancel the booking. It also displays the list of all reserved.",
      codeLink: "https://github.com/Bantealem/space-travelers--hub",
      projectLink:
         "https://space-6755a.web.app/",
      imageUrl: images.viber,
      
   },

   {
      title: "Conference App",
      category: "JavaScript HTML CSS",
      description: "This is an online web development conference website.It features a list of dishes, an about page and partner sections.",
      codeLink: "https://github.com/Bantealem/Conference_app",
      projectLink: "https://graceful-babka-5446c0.netlify.app/",
      imageUrl: images.vibers,
       
    },

   {
      title: "Notion Like Editor",
      category: "React Redux" ,
      description: "This react app is a simple notion like editor app. It changes the text to different types of style and font size.",
      codeLink: "https://github.com/Bantealem/notion-like-editor",
      url: "https://subtle-sprite-7a43a3.netlify.app/",
      imageUrl: images.notion,
    },

        {
        title: "To Do List",
         category: "JavaScript HTML CSS",
        description: "This is a simple to do list app. It allows users to add, edit and delete tasks.",
        codeLink: "https://github.com/Bantealem/Todo_List_app",
        projectLink: "https://thunderous-biscuit-f6cb27.netlify.app/",
        imageUrl: images.todolist,
    },
    {
        title: "Math Magicians",
        category: "React",
        description: " This for all fans of mathematics. It allows users to make calculations and read a random math-related quote",
        codeLink: "https://github.com/Bantealem/math-magicians",
        projectLink: "https://adorable-gnome-477d6e.netlify.app/",
        imageUrl: images.calculator,
    },

   
   
];

export default works;
